import React, { useCallback, useEffect, useState } from 'react';
import './App.css';
import Navigation from './components/Navigation';
import TickerPage from './components/TickerPage';
import TradingDashboard from './components/TradingDashboard';
import HourlyDashboard from './components/HourlyDashboard';
import AdxDashboard from './components/AdxDashboard';
import RsiDashboard from './components/RsiDashboard';
import MacdDashboard from './components/MacdDashboard';
import SignalsDashboard from './components/SignalsDashboard';
import InvestingPage from './components/InvestingPage';
import BondInvestingPage from './components/BondInvestingPage';
import EtpPricesPage from './components/EtpPricesPage';
import EtnPricesPage from './components/EtnPricesPage';
import EtcCotPage from './components/EtcCotPage';
import FxPage from './components/FxPage';
import ContactsPage from './components/ContactsPage';
import ErrorBoundary from './components/ErrorBoundary';
import AuthButtons from './components/AuthButtons';

const VALID_PAGES = [
  'ticker',
  'dashboard',
  'hourly',
  'adx',
  'rsi',
  'macd',
  'signals',
  'investing',
  'bond-investing',
  'macro-stock-bond',
  'macro-btc-nasdaq',
  'macro-gold-usd',
  'macro-commodities',
  'etp-prices',
  'etn-prices',
  'etc-cot',
  'fx',
  'contacts',
];

const DEFAULT_PAGE = 'dashboard';

const INVESTING_WIDE_PAGES = new Set([
  'investing',
  'bond-investing',
  'macro-stock-bond',
  'macro-btc-nasdaq',
  'macro-gold-usd',
  'macro-commodities',
  'etp-prices',
  'etn-prices',
  'etc-cot',
  'fx',
]);

function pageFromUrl() {
  const tab = new URLSearchParams(window.location.search).get('tab');
  return VALID_PAGES.includes(tab) ? tab : DEFAULT_PAGE;
}

function App() {
  const [currentPage, setCurrentPage] = useState(pageFromUrl);

  useEffect(() => {
    const onPopState = () => setCurrentPage(pageFromUrl());
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
    const url = new URL(window.location.href);
    url.searchParams.set('tab', page);
    window.history.pushState({ tab: page }, '', url);
  }, []);

  const investingWide = INVESTING_WIDE_PAGES.has(currentPage);

  return (
    <div className={`container${investingWide ? ' container--investing-wide' : ''}`}>
      <header>
        <div className="header-brand">
          <h1>Sophiatrading</h1>
          <p className="pair-display">Real-time Market Data</p>
        </div>
        <AuthButtons />
      </header>

      <Navigation currentPage={currentPage} onPageChange={handlePageChange} />

      <ErrorBoundary fallbackTitle="This page failed to render">
        <div className={`content${investingWide ? ' content--investing-wide' : ''}`}>
          {currentPage === 'ticker'    && <TickerPage />}
          {currentPage === 'dashboard' && <TradingDashboard />}
          {currentPage === 'hourly'    && <HourlyDashboard />}
          {currentPage === 'adx'       && <AdxDashboard />}
          {currentPage === 'rsi'       && <RsiDashboard />}
          {currentPage === 'macd'      && <MacdDashboard />}
          {currentPage === 'signals'   && <SignalsDashboard />}
          {currentPage === 'investing' && <InvestingPage />}
          {currentPage === 'bond-investing' && <BondInvestingPage view="overview" />}
          {currentPage === 'macro-stock-bond' && <BondInvestingPage view="stock-bond" />}
          {currentPage === 'macro-btc-nasdaq' && <BondInvestingPage view="btc-nasdaq" />}
          {currentPage === 'macro-gold-usd' && <BondInvestingPage view="gold-usd" />}
          {currentPage === 'macro-commodities' && <BondInvestingPage view="commodities" />}
          {currentPage === 'etp-prices' && <EtpPricesPage />}
          {currentPage === 'etn-prices' && <EtnPricesPage />}
          {currentPage === 'etc-cot' && <EtcCotPage />}
          {currentPage === 'fx' && <FxPage />}
          {currentPage === 'contacts' && <ContactsPage />}
        </div>
      </ErrorBoundary>
    </div>
  );
}

export default App;
